/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Pets_QInputs */

const en_road_dude_faq_pets_q = /** @type {(inputs: Road_Dude_Faq_Pets_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I make a Hit the Road Dude video with my dog or cat?`)
};

const zh_road_dude_faq_pets_q = /** @type {(inputs: Road_Dude_Faq_Pets_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以让我的狗狗或猫咪出演吗？`)
};

/**
* | output |
* | --- |
* | "Can I make a Hit the Road Dude video with my dog or cat?" |
*
* @param {Road_Dude_Faq_Pets_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_pets_q = /** @type {((inputs?: Road_Dude_Faq_Pets_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Pets_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_pets_q(inputs)
	return zh_road_dude_faq_pets_q(inputs)
});
export { road_dude_faq_pets_q as "road_dude.faq.pets.q" }